import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AppHeader } from "@/components/AppHeader";
import { PlayVoiceButton } from "@/components/PlayVoiceButton";
import { Heart, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function WordsToLiveBy() {
  const [favorites, setFavorites] = useState(null);

  useEffect(() => {
    api.get("/favorites").then((r) => setFavorites(r.data)).catch(() => setFavorites([]));
  }, []);

  const remove = async (messageId) => {
    try {
      await api.delete(`/favorites/${messageId}`);
      setFavorites((f) => f.filter((x) => x.message_id !== messageId));
    } catch {
      toast.error("Couldn't remove it");
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] grain">
      <AppHeader />
      <main className="max-w-5xl mx-auto px-6 md:px-10 py-12">
        <Link to="/dashboard" className="eyebrow text-[#5C6A61] inline-flex items-center gap-2 hover:text-[#1C221D]" data-testid="words-back">
          <ArrowLeft size={14} /> dashboard
        </Link>
        <div className="eyebrow text-[#E07A5F] mt-8">your collection</div>
        <h1 className="font-serif-display font-light text-5xl sm:text-6xl text-[#1C221D] mt-2">Words to live by</h1>
        <p className="text-[#5C6A61] mt-3 max-w-xl">
          The advice from India that stayed with you. Come back to it whenever you need it.
        </p>

        {favorites && favorites.length === 0 && (
          <div className="mt-12 bg-white rounded-3xl border border-[#2A3B32]/10 p-10 text-center text-[#5C6A61]" data-testid="words-empty">
            <Heart className="mx-auto mb-3 text-[#E07A5F]" size={22} />
            Nothing saved yet. Tap <span className="text-[#1C221D] font-medium">Save</span> under any of India's replies in a conversation.
          </div>
        )}

        <div className="mt-12 columns-1 md:columns-2 gap-6 [&>*]:mb-6" data-testid="words-list">
          {(favorites || []).map((f) => (
            <article
              key={f.id}
              data-testid={`word-${f.message_id}`}
              className="break-inside-avoid bg-white rounded-3xl border border-[#2A3B32]/10 p-7 shadow-[0_8px_30px_rgba(42,59,50,0.04)] fade-up"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="eyebrow text-[#5C6A61]">{f.category}{f.personal ? " · from India personally" : ""}</span>
                <button onClick={() => remove(f.message_id)} data-testid={`unsave-${f.message_id}`} className="text-[#E07A5F] hover:scale-110 transition-transform" aria-label="Remove">
                  <Heart size={16} fill="currentColor" />
                </button>
              </div>
              <p className="font-serif-display text-xl leading-relaxed text-[#1C221D] mt-4 whitespace-pre-wrap">{f.content}</p>
              <div className="mt-5 flex items-center justify-between gap-3">
                <PlayVoiceButton messageId={f.message_id} />
                <span className="text-xs text-[#5C6A61] truncate">
                  {new Date(f.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                </span>
              </div>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}
